import type { V2CatalogEntry } from './types';
import { kitCatalog } from './kit';
import { slot1Catalog } from './slot1';
import { slot2Catalog } from './slot2';
import { slot3Catalog } from './slot3';
import { slot4Catalog } from './slot4';
import { slot5Catalog } from './slot5';
import { slot6Catalog } from './slot6';

export const V2_CATALOG: V2CatalogEntry[] = [
  ...kitCatalog,
  ...slot1Catalog,
  ...slot2Catalog,
  ...slot3Catalog,
  ...slot4Catalog,
  ...slot5Catalog,
  ...slot6Catalog,
].sort((a, b) => a.rank - b.rank);
